/**
 * Gets authentication headers for API requests
 *
 * @returns Object with authentication headers
 */
export const getAuthHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {};

  // Add user authentication header if available
  const userId = localStorage.getItem("userId");
  const email = localStorage.getItem("local_email");

  if (userId) {
    headers["x-mock-auth"] = `user-${userId}`;
  } else if (email) {
    headers["x-mock-auth"] = email;
  }

  return headers;
};
